<template lang="html">
  <b-form class="sticky-top">
    <b-form-row>
      <b-col>
        <b-form-group>
          <Chosen placeholder="[ALL]" :multiple="true" name="select-publishYear" :options="filterValues.publishYears" id="publishYears" :value="filter.publishYears" v-model="filter.publishYears">
            <label slot="label">Publish Year</label>
          </Chosen>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row class="mt-3">
      <b-col cols="6">
        <b-form-group label="Begin Publish Date">
          <datepicker input-class="datePicker" :bootstrap-styling="true" :clear-button="true" :format="dateFormat" id="text-startDate" v-model="filter.startDate" />
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="End Publish Date">
          <datepicker input-class="datePicker" :bootstrap-styling="true" :clear-button="true" :format="dateFormat" id="text-endDate" v-model="filter.endDate" />
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group>
          <Chosen placeholder="[ALL]" :multiple="true" name="select-service" :options="filterValues.services" id="services" :value="filter.service" v-model="filter.service">
            <label slot="label">Service</label>
          </Chosen>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group>
          <Chosen placeholder="[ALL]" :multiple="true" name="select-topic" :options="filterValues.topics" id="topics" :value="filter.topic" v-model="filter.topic">
            <label slot="label">General Topic</label>
          </Chosen>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="12">
        <b-form-group>
          <Chosen placeholder="[ALL]" :multiple="true" name="select-entity" :options="filterValues.associatedEntities" id="entities" :value="filter.entity" v-model="filter.entity">
            <label slot="label">Associated Entity</label>
          </Chosen>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group>
          <Chosen placeholder="[ALL]" :multiple="true" name="select-reports" :options="filterValues.reports" id="reports" :value="filter.report" v-model="filter.report">
            <label slot="label">Report Title</label>
          </Chosen>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group>
          <Chosen placeholder="[ALL]" :multiple="true" name="select-reportNumber" :options="filterValues.reportNumbers" id="reportNumbers" :value="filter.reportNumber" v-model="filter.reportNumber">
            <label slot="label">Report Number</label>
          </Chosen>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group>
          <Chosen placeholder="[ALL]" :multiple="true" name="select-recommendationNumber" :options="filterValues.recommendationNumbers" id="recommendationNumbers" :value="filter.number" v-model="filter.number">
            <label slot="label">Recommendation Number</label>
          </Chosen>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group>
          <Chosen placeholder="[ALL]" :multiple="true" name="select-status" :options="filterValues.implementationStatuses" id="implementationStatuses" :value="filter.implementationStatus" v-model="filter.implementationStatus">
            <label slot="label">Implementation Status</label>
          </Chosen>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="12" class="pt-2">
        <b-button @click="resetFilter" class="reset-button" size="sm">Reset Filters</b-button>
      </b-col>
    </b-form-row>
      <b-form-row>
      <b-col class="pt-1 filteredRecommendationsLabel">
        <p class="text-center font-italic">Filtered Recommendations: {{ recommendations.length }}</p>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import Chosen from '@/components/Chosen.vue'
import $ from 'jquery'
export default {
  props: ['recommendations'],
  components: {
    Chosen,
    Datepicker
  },
  mounted() {
    if (this.$route.query.recommendationNumber && this.$route.query.recommendationNumber.length) {
      this.filter.number = [this.$route.query.recommendationNumber]
    } else if (this.filterValues !== null && this.filterValues.publishYears !== undefined && this.filterValues.publishYears.length > 0) {
      this.filter.publishYears = [this.filterValues.publishYears[0].value.toString()]
    }
  },
  computed: {
    filterValues() {
      return this.$store.getters['oigRecommendations/filterValues']
    }
  },
  data() {
    return {
      filter: {
        reportingPeriod: [],
        topic: [],
        service: [],
        entity: [],
        implementationStatus: [],
        report: [],
        number: [],
        reportNumber: [],
        publishYears: []
      }
    }
  },
  methods: {
    resetFilter() {
      this.filter = {
        reportingPeriod: [],
        topic: [],
        service: [],
        entity: [],
        implementationStatus: [],
        report: [],
        number: [],
        endDate: null,
        startDate: null,
        reportNumber: [],
        publishYears: [this.filterValues.publishYears[0].value.toString()]
      }
    },
    dateFormat(date) {
      date = new Date(date)
      date = new Date((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear())
      return date.toLocaleDateString('en-US')
    },
  },
  watch: {
    filter: {
      handler() {
        this.$emit('applyFilter', this.filter)
      },
      deep: true
    }
  }
}
</script>
<style scoped>
* {
  font-family: Nunito, freight-sans-pro, Sans Source;
}
</style>
<style lang="css">
.filteredRecommendationsLabel {
  font-size: 0.7rem;
}

.form-control {
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0 5px;
  width: 100%;
  height: auto;
  border: 1px solid #aaa;
  background-color: #fff;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(1%, #eee), color-stop(15%, #fff));
  background-image: linear-gradient(#eee 1%, #fff 15%);
  border-radius: 0;
  cursor: text;
}

.btn.reset-button {
  font-size: 0.7rem;
  padding: 2%;
  -webkit-border-radius: 0.2rem;
  border-radius: 0.2rem
}

.filter {
  border-right: 0.1rem solid black;
}

.datePicker {
  background-color: white !important;
  padding: .375rem;
}

span.input-group-text,
.vdp-datepicker__calendar {
  font-size: 0.5rem;
}

form p {
  margin-top: 0;
  margin-bottom: 1rem;
}

.form-group label,
.form-group legend,
.custom-select,
.datePicker {
  font-size: 0.5rem !important;
}

.vdp-datepicker .input-group-text {
/*  border-radius: 0 .25rem .25rem 0 !important; */
}

.filter .form-group span.col-12 {
  width: 100%;
  padding: 0;
}

</style>
